// N-up imposition: how many finished pieces fit on one press sheet.
// Same idea as FileSplice's MIT n-up calculator (linked in NMS's "Useful
// Links"), reimplemented so customers can enter a finished size instead of
// knowing what "N-up" means. Margin and gutter defaults are placeholders
// until NMS confirms its press setup.

const fit = (sheetW, sheetH, w, h, margin, gutter) => {
  const cols = Math.floor((sheetW - 2 * margin + gutter) / (w + gutter));
  const rows = Math.floor((sheetH - 2 * margin + gutter) / (h + gutter));
  return Math.max(0, cols) * Math.max(0, rows);
};

/** Max pieces of w x h (inches) per sheet, trying both orientations. */
export function piecesPerSheet(sheet, piece, { marginIn = 0.25, gutterIn = 0.125 } = {}) {
  const [sw, sh] = sheet;
  const [w, h] = piece;
  if (!(w > 0 && h > 0)) return 0;
  return Math.max(fit(sw, sh, w, h, marginIn, gutterIn), fit(sw, sh, h, w, marginIn, gutterIn));
}

/** Sheet size parsed from a stock label such as '100# Cover ... 12x18'. */
export function sheetFromLabel(label) {
  const sizes = [...String(label).matchAll(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/gi)];
  const last = sizes.at(-1);
  return last ? [Number(last[1]), Number(last[2])] : null;
}

/**
 * Largest N-up the price sheet offers that the piece actually fits.
 * @param {number} fits    pieces per sheet from piecesPerSheet()
 * @param {number[]} offered  N-up values with price tables, e.g. [1,2,3,4,8,10,12]
 */
export const bestOfferedUp = (fits, offered) =>
  [...offered].sort((a, b) => b - a).find((n) => n <= fits) ?? null;
